import { Box, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

interface StatusTagProps {
  text?: string;
  fontColor?: string;
  bgColor?: string;
  sx?: SxProps<Theme>;
  width?: string | number;
}

function StatusTag({
  text,
  fontColor,
  bgColor,
  sx,
  width = "100%",
}: StatusTagProps) {
  if (!text) return null;

  return (
    <Box
      width={width}
      py={0.75}
      pl={1.25}
      pr={1}
      borderLeft={`4px solid ${fontColor}`}
      bgcolor={bgColor}
      sx={sx}
    >
      <Typography
        fontSize={13}
        fontWeight={700}
        color={fontColor}
        lineHeight={1.3}
        letterSpacing={0.2}
      >
        {text}
      </Typography>
    </Box>
  );
}

export { StatusTag };
